exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container {\n  margin-bottom: 1.5rem; }\n  .login-container .login-bar {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n    .login-container .login-bar .computer {\n      margin-top: 1.25rem; }\n  .login-container .login-form {\n    margin-top: 1.5rem; }\n    .login-container .login-form .input-container img {\n      height: 35px;\n      margin-top: -5rem;\n      margin-left: 0.6rem; }\n    .login-container .login-form button {\n      width: 150px; }\n    .login-container .login-form a {\n      text-decoration: none;\n      text-underline: none;\n      padding: 0.3rem 0 1.25rem; }\n  .login-container .text-form {\n    font-size: 16px; }\n  .login-container .align-right {\n    margin-left: auto;\n    margin-right: 0; }\n  .login-container .text-uppercase {\n    text-transform: uppercase; }\n  .login-container input {\n    font-family: GalanoGrotesque-Light, sans-serif;\n    padding-left: 2.8rem; }\n  .login-container label {\n    font-weight: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/login/login.component.scss
// module id = ../../../../../src/app/login/login.component.scss
// module chunks = main